<template>
  <div class="app-main-content operationRobot">
    <div class="main-content">
      <div>
        <!-- <el-button type="primary" @click="query">查询</el-button> -->
        <!-- <el-button>重置</el-button> -->
        <el-button type="primary" @click="addRobotShow = true">新增机器人</el-button>
      </div>
      <!-- <div class="section" style="background-color:#fff;margin-top:6px;">
        <el-form :inline="true" label-width="80px">
          <el-form-item label="机器人名称">
            <el-input v-model="robotName" placeholder="请输入机器人名称" />
          </el-form-item>
        </el-form>
      </div> -->
      <div class="section" style="background-color:#fff;margin-top:6px;">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="序号" prop="sorting" width="50" />
          <el-table-column label="机器人名称" prop="taskName" />
          <el-table-column label="机器人属性" prop="robotAttribute" />
          <el-table-column label="机器人状态">
            <template slot-scope="scope">
              <span :class="[scope.row.taskStatus === 1?'setColorBlue':'setColorGray']">{{ taskStatus(scope.row.taskStatus) }}</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="300">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="runImmediately(scope.row)">立即运行</el-button>
              <el-button type="text" size="small" @click="operationPlan(scope.row)">运行计划</el-button>
              <!-- <el-button v-show="scope.row.taskStatus === 1" type="text" size="small" @click="cancelOperationFunc(scope.row)">取消运行</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="addRobotShow"
      title="新增机器人"
      width="360px"
      :close-on-click-modal="false"
    >
      <div>
        <el-checkbox-group v-model="checkList" class="add-robot" @change="statusChange()">
          <el-checkbox v-for="item in robotList" :key="item.uuid" style="margin-bottom:5px;" :label="item.taskName" :value="item.uuid" />
        </el-checkbox-group>
      </div>
      <div slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="addRobotFunc">新增</el-button>
      </div>
    </el-dialog>
    <plan-dialog
      ref="planDialog"
      :dialog-form="dialogForm"
      :robot-list="robotList"
      @planCancel="planCancel"
      @nextStep="nextStep"
    />
    <configuration-dialog
      ref="configurationDialog"
      :configuration-form="configurationForm"
      @configurationCancel="configurationCancel"
      @runCreate="runCreate"
      @lastStep="lastStep"
      @createPlan="createPlan"
    />
  </div>
</template>
<script>
import planDialog from './components/planDialog'
import configurationDialog from './components/configurationDialog'
import { getList, addRobot, taskConfigs } from '@/api/robot/operationRobot'
import { addOrUpdateRobot } from '@/api/robot/programManagement'
import { getLoading } from '@/utils/utilBaseElement'
export default {
  name: 'OperationRobot',
  components: { planDialog, configurationDialog },
  data() {
    return {
      addRobotShow: false,
      dialogForm: {
        show: false,
        editor: true
      },
      configurationForm: {
        show: false,
        buttonShow: false,
        editor: true
      },
      loading: false,
      form: {},
      taskConfigUuid: '',
      robotList: [],
      checkedId: '',
      checkList: [],
      tableData: [],
      robotName: ''
    }
  },
  created() {
    this.getListFunc()
    this.taskConfigsList()
  },
  methods: {
    // 获取机器人列表
    async getListFunc() {
      this.loading = getLoading()
      const res = await getList().finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        if (res.data.length !== 0) {
          res.data.forEach((item, index) => {
            item.sorting = index + 1
            item.robotAttribute = '免费'
          })
        }
        this.tableData = res.data
      } else {
        this.tableData = []
      }
    },
    // 获取系统机器人列表
    async taskConfigsList() {
      const res = await taskConfigs()
      if (res.ok) {
        this.robotList = res.data
        this.checkList = [res.data[0].taskName]
        this.checkedId = res.data[0].taskName
      } else {
        this.robotList = []
      }
    },
    // 确认新增机器人
    async addRobotFunc() {
      this.loading = getLoading()
      const taskConfigData = this.robotList.filter((item) => {
        return item.taskName === this.checkList[0]
      })
      const data = {
        taskConfigUuid: taskConfigData[0].uuid
      }
      const res = await addRobot(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        this.getListFunc()
        this.$message.success('添加成功')
        this.addRobotShow = false
      }
    },
    // 运行
    async runCreate(form) {
      this.planRequest(form, 9)
    },
    // 取消运行
    // cancelOperationFunc() {
    //   this.$confirm('确认取消该任务？', '温馨提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     const data = {}
    //     cancelOperation(data).then((res) => {
    //       if (res.ok) {
    //         this.getListFunc()
    //         this.$message.success('取消成功')
    //       }
    //     })
    //   })
    // },
    // 打开立即运行弹窗
    runImmediately(row) {
      this.taskConfigUuid = row.taskConfigUuid
      this.$refs.configurationDialog.params(row)
      // if (row.taskStatus === 1) {
      //   return
      // }
      this.configurationForm = {
        show: true,
        buttonShow: false,
        editor: true
      }
    },
    async planRequest(form, type) {
      let data = {}
      // type===9为立即运行 1为运行计划
      if (type === 9) {
        data = {
          taskConfigUuid: this.taskConfigUuid,
          dataInfo: form.dataInfo,
          taskRunDateTimeLong: null,
          taskRunningPlan: 9,
          notifyEmail: form.email
        }
      } else {
        data = {
          taskConfigUuid: this.form.robotName,
          scheduleName: this.form.planName,
          dataInfo: form.dataInfo,
          taskRunningPlan: this.form.frequency,
          notifyEmail: form.email
        }
        // frequency === 0为单次运行，1为每天运行，处理不同的返回时间格式
        if (this.form.frequency === 0) {
          console.log('this.form.selectDate', this.form.selectDate)
          let dateTime = `${this.form.selectDate} ${this.form.elapsedTime}`
          dateTime = new Date(dateTime).valueOf()
          data.taskRunDateTimeLong = dateTime
        } else {
          console.log('this.form.selectDateArr', this.form.selectDateArr)
          const startTime = new Date(this.form.selectDateArr[0]).valueOf()
          const endTime = new Date(this.form.selectDateArr[1]).valueOf()
          data.taskDailyStartLong = startTime // 每天开始日期
          data.taskDailyEndLong = endTime // 每天结束日期
          data.taskDailyTimeString = this.form.elapsedTime // 每天运行时间
          if (this.form.elapsedTime.length === 5) {
            data.taskDailyTimeString = `${this.form.elapsedTime}:00`
          }
        }
      }
      this.loading = getLoading()
      const res = await addOrUpdateRobot(data, 'post').finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        this.$refs.planDialog.reset()
        this.$message.success('添加成功')
        this.getListFunc()
        this.configurationCancel()
        this.$refs.configurationDialog.reset()
      }
    },
    // 创建计划
    async createPlan(form) {
      this.planRequest(form, 1)
    },
    // 运行计划
    operationPlan(row) {
      this.$refs.configurationDialog.params(row)
      this.taskConfigUuid = row.taskConfigUuid
      this.dialogForm.show = true
    },
    // 新增机器人弹窗关闭
    cancel() {
      this.addRobotShow = false
    },
    // 运行计划弹窗关闭
    planCancel() {
      this.dialogForm.show = false
      this.$refs.planDialog.reset()
      this.$refs.configurationDialog.reset()
    },
    // 运行计划下一步弹窗打开
    nextStep(form) {
      this.form = form
      this.configurationForm = {
        show: true,
        buttonShow: true,
        editor: true
      }
    },
    // 运行计划第二步弹窗关闭
    configurationCancel() {
      this.lastStep()
      this.planCancel()
    },
    // 关闭配置弹窗
    lastStep() {
      this.configurationForm.show = false
    },
    // 新增机器人弹窗内勾选切换，目前只有一项
    statusChange() {
      if (this.checkList.length > 1 && this.checkList.length !== 0) {
        this.checkList.splice(0, 1)
        this.checkedId = this.checkList[0]
      } else {
        this.checkList.push(this.checkedId)
      }
    },
    // 转换机器人状态值
    taskStatus(taskStatus) {
      switch (taskStatus) {
        case 0:
          return '未运行'
        case 1:
          return '运行中'
      }
    }
  }
}
</script>
<style lang="scss">
.operationRobot{
  .setColorBlue{
    color:#1F75D5;
  }
  .setColorGray{
    color:#97a8be;
  }
  .banClick{
    opacity: 0.5;
  }
  .add-robot{
    padding-left:20px;
    display: flex;
    flex-direction: column;
  }
}

</style>
